export default __webpack_public_path__ + "static/media/hero@2x.87cee7e6.webp";